import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin'

function ItemsModal({ open, handleClose, reservation }) {
    const translate = useTranslate()

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle> {translate('ra.title.reservationItems')} {reservation ? reservation.number : "No disponible"}</DialogTitle>
            <DialogContent>
                {reservation && reservation.items && reservation.items.length > 0 ? (
                    <>
                        <div className='scrollingContainer'>
                            <table className="tableInfoConfimation">
                                <thead>
                                    <tr className="tableHead">
                                        <th className="cell">Item</th>
                                        <th className="cell"> {translate('ra.field.currencyType')} </th>
                                        <th className="cell">{translate('ra.field.currency')}</th>
                                        <th className="cell">{translate('ra.field.totalAmount')}</th>
                                        <th className="cell">{translate('ra.field.paidAmount')}</th>
                                        <th className="cell">{translate('ra.field.pendingAmount')}</th>
                                        <th className="cell">{translate('ra.field.due_date')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reservation.items.map((item, index) => (
                                        <tr className="tableBody" key={index}>
                                            <td className="cell" align="center">{item.product_type}</td>
                                            <td className="cell" align="center">
                                                <div style={{ paddingBottom: '4px' }}>
                                                    {translate('ra.field.reserve')}
                                                </div>
                                                <div style={{ paddingTop: '4px' }}>
                                                    {translate('ra.field.payment')}
                                                </div>
                                            </td>
                                            <td className="cell" align="center">
                                                <div style={{ paddingBottom: '4px' }}>
                                                    {item.item_prices.origin_currency}
                                                </div>
                                                <div style={{ paddingTop: '4px' }}>
                                                    {item.item_destination_prices.destination_currency}
                                                </div>
                                            </td>
                                            <td className="cell" align="center">
                                                <div style={{ paddingBottom: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_prices.total_amount))}
                                                </div>
                                                <div style={{ paddingTop: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_destination_prices.total_amount))}
                                                </div>
                                            </td>
                                            <td className="cell" align="center">
                                                <div style={{ paddingBottom: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_prices.paid_amount))}
                                                </div>
                                                <div style={{ paddingTop: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_destination_prices.paid_amount))}
                                                </div>
                                            </td>
                                            <td className="cell" align="center">
                                                <div style={{ paddingBottom: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_prices.pending_amount))}
                                                </div>
                                                <div style={{ paddingTop: '4px' }}>
                                                    {new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(item.item_destination_prices.pending_amount))}
                                                </div>
                                            </td>
                                            <td className="cell">{item.payment_due_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <Typography variant="body1"> {translate('ra.message.noInformationAvailable')} </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default ItemsModal;